export const ORDER_NAME_KEY = 'lkOrderName'
export const BASKET_KEY = 'personalBasketAppscience'
export const CURRENCY_KEY = 'lkUserCurrency'
export const DELIVERY_CITY_KEY = 'lkDeliveryCity'
